module.exports = __webpack_public_path__ + "img/tr.7c531f04.png";